import { IDepartmentInfo } from '../models/tenant-user-access.model';

export function isDepartmentPaused(department: IDepartmentInfo | undefined | null): boolean {
  return !!department?.pause?.isPaused;
}
